import React, { useMemo, useState } from 'react';

import { ControlBar, ControlGroup, ControlSearchBox } from 'src/app/components/lib/control-bar';
import { ModalDataGrid } from 'src/app/components/lib/table';
import { FullWidthWizardCard } from 'src/app/components/lib/wizard/card/full-width-card';
import { MarketingDiscountsDiscountWizardProductList } from 'src/app/constants/table-names';
import { useDiscountProductsQuery } from 'src/app/queries/discounts/get-discount-products';

import { ProductListGridWrapper } from '../../shared/styled';
import { useAllFilteredProducts } from '../../shared/use-filtered-products';
import { useProductListColumns } from '../../shared/use-product-list-columns';

export function ProductListCard() {
  const [searchString, setSearchString] = useState('');

  const { isLoading: productsLoading } = useDiscountProductsQuery();
  const filteredProductsFromResourceFilters = useAllFilteredProducts();

  const filteredProductsFromSearchString = useMemo(
    () =>
      filteredProductsFromResourceFilters.filter(
        (product) =>
          product.ProductDesc.toLowerCase().includes(searchString.toLowerCase()) ||
          product.ProductNo.toLowerCase().includes(searchString.toLowerCase())
      ),
    [filteredProductsFromResourceFilters, searchString]
  );

  const columns = useProductListColumns();
  return (
    <FullWidthWizardCard
      compact
      description='The discount method will be applied to the following products.'
      title='Products specified in requirements'
    >
      <ProductListGridWrapper>
        <ControlBar margin='0 0 var(--sizes-30)'>
          <ControlGroup grow>
            <ControlSearchBox placeholder='Search products by name or SKU' onChange={setSearchString} />
          </ControlGroup>
        </ControlBar>
        <ModalDataGrid
          autoHeight
          columns={columns}
          disableRowHoverHighlight
          disableSelectionOnClick
          getRowId={(row) => row.ProductId}
          height='400px'
          hideActionsColumn={false}
          loading={productsLoading}
          name={MarketingDiscountsDiscountWizardProductList}
          rows={filteredProductsFromSearchString}
        />
      </ProductListGridWrapper>
    </FullWidthWizardCard>
  );
}
